import { render, staticRenderFns } from "./CreateNewDevice.vue?vue&type=template&id=cb39490c&scoped=true"
import script from "./CreateNewDevice.vue?vue&type=script&lang=js"
export * from "./CreateNewDevice.vue?vue&type=script&lang=js"
import style0 from "./CreateNewDevice.vue?vue&type=style&index=0&id=cb39490c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb39490c",
  null
  
)

export default component.exports